import { useState } from 'react';

// Forcefully triggers a render cycle
export default function useForceRerender() {
  const [, setValue] = useState(false);
  return () => setValue((value) => !value);
}
